export enum SubscriptionPlan {
  FREE = 'FREE',
  STARTER = 'STARTER',
  PRO = 'PRO',
  ENTERPRISE = 'ENTERPRISE',
  CLIENT_FREE = 'CLIENT_FREE',
  CLIENT_PRO = 'CLIENT_PRO',
  /** What a property-manager org holds before it subscribes. */
  PROPERTY_MANAGER_FREE = 'PROPERTY_MANAGER_FREE',
  /** The three PM bands (EE-500): chosen by the declared unit count, never picked directly. */
  PM_STARTER = 'PM_STARTER',
  PM_PROFESSIONAL = 'PM_PROFESSIONAL',
  PM_ENTERPRISE = 'PM_ENTERPRISE'
}


export function isUpgrade(fromPlan: SubscriptionPlan, toPlan: SubscriptionPlan) {
  return fromPlan !== toPlan && ((fromPlan === SubscriptionPlan.FREE && toPlan !== SubscriptionPlan.FREE) ||
    (fromPlan === SubscriptionPlan.STARTER && (toPlan === SubscriptionPlan.ENTERPRISE || toPlan === SubscriptionPlan.PRO)) ||
    (fromPlan === SubscriptionPlan.PRO && toPlan === SubscriptionPlan.ENTERPRISE));
}

export function isDowngrade(fromPlan: SubscriptionPlan, toPlan: SubscriptionPlan) {
  return fromPlan !== toPlan && ((fromPlan === SubscriptionPlan.ENTERPRISE && toPlan !== SubscriptionPlan.ENTERPRISE) ||
    (fromPlan === SubscriptionPlan.PRO && (toPlan === SubscriptionPlan.STARTER || toPlan === SubscriptionPlan.FREE)) ||
    (fromPlan === SubscriptionPlan.STARTER && toPlan === SubscriptionPlan.FREE));
}
